import {
  normalizePagesWorkspaceLayout,
  relayoutPagesForMode,
} from '@/components/canvas/workspace/model/pageArrangement';
import type { Element, Page, WorkspacePageLayoutMode } from '@/components/canvas/document/publicTypes';
import {
  DEFAULT_WORKSPACE_PAGE_LAYOUT_MODE,
  isWorkspacePageLayoutMode,
} from '@/components/canvas/workspace/model/workspacePageLayoutMode';
import type { SliceDeps } from '../deps';

export function createLoadStateAction({ set }: SliceDeps) {
  return {
    loadState: (
      nextPages: Page[],
      nextWorkspaceElements?: Element[],
      viewport?: { zoom: number; panX: number; panY: number },
      workspacePageLayoutMode?: WorkspacePageLayoutMode,
    ) => {
      const ws = nextWorkspaceElements ?? [];
      const resolvedMode = isWorkspacePageLayoutMode(workspacePageLayoutMode)
        ? workspacePageLayoutMode
        : DEFAULT_WORKSPACE_PAGE_LAYOUT_MODE;
      const normalized = normalizePagesWorkspaceLayout(nextPages);
      /** 激活页仅会话态：载入/换文档时固定为第一页（与持久化 JSON 解耦） */
      const focusPageId = normalized[0]?.id ?? '';
      const pages =
        resolvedMode === 'single' || resolvedMode === 'vertical'
          ? relayoutPagesForMode(
              normalized,
              resolvedMode,
              viewport?.zoom ?? 1,
              resolvedMode === 'single' ? focusPageId : undefined,
            )
          : normalized;
      set({
        pages,
        currentPageId: focusPageId,
        workspaceElements: ws,
        workspacePageLayoutMode: resolvedMode,
        ...(viewport
          ? {
              zoom: viewport.zoom,
              panX: viewport.panX,
              panY: viewport.panY,
            }
          : {}),
        _history: [],
        _historyIndex: -1,
        canUndo: false,
        canRedo: false,
        selectedElementIds: [],
        selectedBlockIds: [],
        hoveredBlockId: null,
        selectedPageIds: [],
        selectionScope: null,
        isPageSelected: false,
        /** 表格单元格/行列子选为会话态，不写入文档；换文档须清空 */
        selectedTableColumn: null,
        selectedTableRow: null,
        selectedTableCells: null,
        editingTableCellId: null,
        
        editingTextId: null,
        editingGroupId: null,
        _pendingBase: null,
      });
    },
  };
}
